import EntityPresenter, { bindPresenterMethods } from './entityPresenter'
import qs from 'qs'

export default class NodePresenter extends EntityPresenter {
  static urn = 'nodes'
  static key = 'node'

  static tree({ depth = 1, ...query } = {}) {
    return this.get('tree', { depth, ...query }, { force: true })
  }

  static treeStates({ depth = 1, ...query } = {}) {
    return this.get(`tree/sensors/states`, { depth, ...query })
  }

  static listNodes(params, options) {
    return this.get(null, null, {
      filter: qs.stringify(params, { ...options }),
      force: true,
    })
  }

  static parents(childrenId, { depth, ...query } = {}) {
    return this.get(`parents/${ childrenId }`, { depth, ...query })
  }

  static navOptions(key = 'nodes') {

    const routes = {
      nodes: {
        icon: 'device_hub',
        pageRoutes: ['node'],
      },
    }
    return routes[key]
  }
}

bindPresenterMethods(NodePresenter)
